import { useMemo } from 'react';
import { mediaManagerLayoutChanged, mediaManagerLayoutClick } from '@wix/bi-logger-media-data/v2';

import { bi } from '../../../services/loggers/bi';
import { toSettingsLayout } from '../../layout';

export enum LayoutChangeClickOrigin {
  TopRight = 'topRight',
  Actions = 'actions',
}

export const useTrackLayoutChange = (tabName?: string) =>
  useMemo(
    () => ({
      trackLayoutClick: (clickOrigin) =>
        bi.logger().report(mediaManagerLayoutClick({ clickOrigin, ...(tabName ? { tabName } : {}) })),
      trackLayoutChange: (previousLayout, currentLayout) =>
        bi.logger().report(
          mediaManagerLayoutChanged({
            previousSelection: toSettingsLayout(previousLayout),
            layout: toSettingsLayout(currentLayout),
            ...(tabName ? { tabName } : {}),
          }),
        ),
    }),
    [tabName],
  );
